export const SET_DATA_CARDS = "SET_DATA_CARDS";
export const SET_INDICADORES = "SET_INDICADORES";
export const SET_FLAG_FOR_LOADER_CARDS = "SET_FLAG_FOR_LOADER_CARDS";
export const SET_FLAG_FOR_LOADER_ECONOMICS = "SET_FLAG_FOR_LOADER_ECONOMICS";
export const SET_FLAG_FOR_LOADER_LINKS = "SET_FLAG_FOR_LOADER_LINKS";
export const SET_FLAG_FOR_LOADER_UTILITIES = "SET_FLAG_FOR_LOADER_UTILITIES";
export const SET_FLAG_FOR_LOADER_DOCUMENT = "SET_FLAG_FOR_LOADER_DOCUMENT";

export const CLEAN_COUNTER__STEP__HOME_ONBOARDING = "CLEAN_COUNTER__STEP__HOME_ONBOARDING";
export const COUNTER__STEP__HOME_ONBOARDING = "COUNTER__STEP__HOME_ONBOARDING";